import * as React from "react";
const SvgBedEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M19 7H5v7H3V5H1v15h2v-3h18v3h2v-9a4 4 0 0 0-4-4" }));
export default SvgBedEmpty;
